import {
    Component,
    ViewChild,
    ElementRef,
    Input,
    ViewEncapsulation,
    Output,
    EventEmitter,
    AfterViewChecked,
    OnDestroy,
    HostListener,
    ApplicationRef,
    ComponentFactoryResolver,
    Injector,
    Renderer2
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import 'slickgrid/lib/jquery.event.drag-2.3.0';
import 'slickgrid/lib/jquery.mousewheel';
import 'slickgrid/slick.core';
import 'slickgrid/slick.grid';
import 'slickgrid/slick.editors';
import 'slickgrid/slick.dataview';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import 'slickgrid/plugins/slick.rowselectionmodel';
import 'slickgrid/plugins/slick.cellselectionmodel';
import 'slickgrid/plugins/slick.cellrangeselector';
import 'slickgrid/plugins/slick.cellrangedecorator';
import 'slickgrid/plugins/slick.headerbuttons';
import 'slickgrid/slick.groupitemmetadataprovider';
import 'slickgrid-column-data-autosize/dist/slick.autocolumnsize';
import 'slickgrid/plugins/slick.cellexternalcopymanager';
import * as Popper from 'popper.js/dist/umd/popper';

import {IAngularEditor} from 'app/slick-grid/interfaces/angular-editor';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {IDataSorter} from 'app/slick-grid/interfaces/data-sorter';
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column'
import {DropdownFilterType} from 'app/slick-grid/interfaces/dropdown-filter-type';
import {OnDropdownFilteredEventArgs} from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import {StocksHelper} from 'app/stocks/models/stocks-helper'
import {SlickGridFilterHelper} from 'app/slick-grid/models/slick-grid-filter-helper'
import {OnGroupingEventArgs} from "./models/on-grouping-event-args";
import {AggregationSelector, Aggregation} from "../stocks/models/aggregation-selector";
import {GetSlickGridProp} from "../shared/models/get-slick-grid-prop";
import {CommonDataService} from "../services/common-data.service";
import {SlickGridColumns} from "../shared/models/slick-grid-columns";
import {SlickFilterItem} from "./models/slick-filter-item";
import {UniversalListSettings} from "../shared/models/universal-list";
import {ColumnsGenerator} from "./models/columns-generator";
import {ColumnSettingsBase} from "./models/column-settings-base";
import {ModuleTableName} from "../shared/models/module-table-name";
import EditorLock = Slick.EditorLock;
import * as moment from 'moment';
import { Moment } from 'moment';


export class SlickGridComponentBase implements AfterViewChecked, OnDestroy{
    constructor(
        private readonly appRef: ApplicationRef,
        private readonly resolver: ComponentFactoryResolver,
        private readonly injector: Injector,
        public readonly renderer: Renderer2,
        public readonly translateService: TranslateService,
        private readonly elementRef: ElementRef,
        private readonly commonData: CommonDataService
    ){
        this.onClick = new EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>();
        this.onDblClick = new EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>();
        this.onKeyDown = new EventEmitter<EventArgs<Slick.OnKeyDownEventArgs<any>>>();
        this.onActiveCellChanged = new EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>();
        this.onActiveCellPositionChanged = new EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>();
        this.onSort = new EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>();
        this.onSorted = new EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>();
        this.onBeforeEditCell = new EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>(false);
        this.onCellChange = new EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>();
        this.onBeforeCellEditorDestroy = new EventEmitter<EventArgs<Slick.OnBeforeCellEditorDestroyEventArgs<any>>>();
        this.onViewportChanged = new EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>();
        this.onSelectedRowsChanged = new EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>();
        this.onHeaderCellRendered = new EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>();
        this.onFiltered = new EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>();
        this.appliedFilters = new EventEmitter<{filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[]}>();
        this.onGrouping = new EventEmitter<EventArgs<OnGroupingEventArgs<any>>>();
        this.onAggregated = new EventEmitter<EventArgs<OnGroupingEventArgs<any>>>();
        //this.onInitialized = new EventEmitter<EventArgs<Slick.Grid<any>>>();
        this.onColumnsResized = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();
        this.onValidatorError = new EventEmitter<EventArgs<Slick.OnValidationErrorEventArgs<any>>>();
        this.onHeaderContextMenu = new EventEmitter<EventArgs<Slick.OnHeaderContextMenuEventArgs<any>>>();
        this.onContextMenu = new EventEmitter<EventArgs<Slick.OnContextMenuEventArgs<any>>>();
        this.onReady = new EventEmitter<boolean>();
        this.onDestroy = new EventEmitter<boolean>();
        //this.onColumnsReordered = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();

        this.filteredColumns = [];
        this.helper = new StocksHelper();
        this.filterHelper = new SlickGridFilterHelper();
        this.unListSorter = new DataSorter<any>();
        this.translates = {NoData: 'No data'};
        this.gridGUID = this.helper.generateGUID();

        this.unListSorter.customComparers['name'] = (a, b) => {
            const A = a.value, B = b.value;
            return A === B ? 0 : A > B ? 1 : -1;
        };

        //this.translateService.use(sessionStorage.getItem('userLocale'));
        //console.log(sessionStorage.getItem('userLocale'));
    }

    @ViewChild('grid')
    private gridRef: ElementRef;

    //private gridWidth: number;
    //@Input()
    //set width(value: number) {
    //    if (value)
    //        this.gridWidth = value;
    //}
    //get width(): number {
    //    return this.gridWidth;
    //}

    //private gridHeight: number;
    //@Input()
    //set height(value: number) {
    //    if (value)
    //        this.gridHeight = value;
    //}
    //get height(): number {
    //    return this.gridHeight;
    //}

    private dataView: Slick.Data.DataView<any>;
    private data: Slick.Data.DataView<any> | any[];

    //# set data to grid
    @Input('data')
    set dataInput(data: Slick.Data.DataView<any> | any[]){
        this.removeDataViewListeners();

        this.data = data || [];
        if (this.data instanceof Slick.Data.DataView){
            this.dataView = this.data as Slick.Data.DataView<any>;
        } else{
            this.dataView = new Slick.Data.DataView<any>();
        }

        this.dataView.onRowCountChanged.subscribe(this.onDataViewRowCountChanged);
        this.dataView.onRowsChanged.subscribe(this.onDataViewRowsChanged);

        if (!this.grid)
            return;

        if (this.data instanceof Slick.Data.DataView)
            this.grid.setData(this.data as Slick.Data.DataView<any>, true);
        else
            this.grid.setData(this.data as any[], true);
        this.grid.render();
        this.toggleHideGridFunc();

    }

    // private renderedColumns: Slick.OnHeaderCellRenderedEventArgs<any>[];
    private columns: Slick.Column<any>[];

    //# set columns to grid
    @Input('columns')
    set columnsInput(columns: Slick.Column<any>[]){
        const setColumns = (): void =>{

            this.columns = columns;
            // this.columns.push({ id: 'id', field: 'id', name: '', sortable: true, width: 0, minWidth: 0, maxWidth: 0, cssClass: 'd-none-grid', headerCssClass: 'd-none-grid'});
            if (this.grid)
                this.setColumns(this.columns);
            if (this.filteredColumns && this.filteredColumns.length)
                this.filteredColumns = [];
        };

        if (!columns || !columns.length){
            columns = [];
            setColumns();
            return;
        }

        setColumns();

        //# translate columns names
        this.translateService.get(columns.map(c => c.name)).subscribe(names =>{
            columns.forEach(c => c.name = names[c.name]);
            setColumns();
        });
    }

    private options: Slick.GridOptions<any>;

    //# set options for grid
    @Input('options')
    set optionsInput(options: Slick.GridOptions<any>){
        this.options = options || {};
        if (this.grid){
            this.grid.setOptions(this.options);
        }

    }

    private css: string[];

    //# add classes to grid
    @Input()
    set cssClasses(css: string[]){
        if (!this.gridRef){
            this.css = css;
            return;
        }

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.remove(c));

        this.css = css;

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.add(c));
    }

    private cellStyles: { [key: string]: Slick.CellCssStylesHash }

    //# set styles for grid cells
    @Input()
    set cellCssStyles(value: { [key: string]: Slick.CellCssStylesHash }){

        this.removeCellStyles();

        this.cellStyles = value;

        this.setCellStyles();
    }

    private selection: Slick.SelectionModel<any, Slick.Range[]>;

    //# set selection model for grid
    @Input()
    set selectionModel(value: Slick.SelectionModel<any, Slick.Range[]>){
        this.selection = value;

        if (this.grid)
            this.grid.setSelectionModel(value);
    }

    private sorter: IDataSorter<any>;

    //# set sorter, use when sort data in grid
    @Input()
    set dataSorter(value: IDataSorter<any>){
        if (value){
            this.sorter = value;
        }

    }

    //# deny, add aggregation from column header
    @Input()
    private denyAggregation?: boolean;

    //# deny filters from column header
    @Input()
    private denyFilters?: boolean;

    //# function for custom sort after load properties
    @Input()
    private sortColumns?: (columns: any[]) => void;

    //# deny, add grouping and aggregation from column header
    @Input()
    private denyGrouping?: boolean;

    //# deny, add grouping and aggregation from column header
    @Input()
    private filtersCssClass?: string[];

    //# filters behavior
    @Input()
    private filterBehaviorIn?: HTMLElement;

    //# filters behavior
    @Input()
    private test?: any;

    @Input()
    private cancelSort?: boolean;

    @Input()
    private manualEllipsis?: {paddingWidth: number, strings: number, fontSize: number};

    private _showNoData: boolean;

    //# show nodata message if grid not contains data
    @Input()
    private set showNoData(val: boolean){
        // console.log(val, this.dataView.getItems().length, 'showNoData')
        this._showNoData = val
    };

    private get showNoData(): boolean{
        return this._showNoData;
    };

    private propsName: { moduleName: string, tableName: string };

    //# set grip properties, by this data we download grid properties (columns width and order)
    @Input('propsName')
    set setPropsName(val: ModuleTableName){
        if (val && val.moduleName && val.tableName){
            this.propsName = val;
            this.setSlickGridProps();
        } else{
            this.propsName = null;
        }
    }

    private grid: Slick.Grid<any>;

    private helper: StocksHelper;

    public filterHelper: SlickGridFilterHelper;

    private pluginsToRegister: Slick.Plugin<any>[];

    private gridInitiating: boolean;

    private _hideGrid: boolean;

    private set hideGrid(val: boolean){
        // console.log(val, this.dataView.getItems().length, 'hideGrid')
        this._hideGrid = val
    };

    private get hideGrid(): boolean{
        return this._hideGrid;
    };

    public translates: any;

    private slickGridProp: SlickGridColumns[];

    private resizeGridViewChecked: boolean;

    private universalData: SlickFilterItem[];

    private universalSettings: UniversalListSettings;

    private universalBTN: HTMLElement;

    private updatePopper: number;

    private dropDownPopper: Popper;

    public unColSettings: ISlickGridColumn<any>[];

    public applyFilter: (event: {data: any[], selected: any[]}) => void;

    public showUnList: boolean;

    public gridGUID: string;

    private unListSorter: DataSorter<any>;

    private filterBehavior: HTMLElement;

    //# standart grid events reemitted from component

    //# emit click event, if make click on grid
    @Output()
    private readonly onClick: EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>;

    //# emit click event, if double click on grid
    @Output()
    private readonly onDblClick: EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>;

    //# emit KeyDown event, if KeyDown click on grid
    @Output()
    private readonly onKeyDown: EventEmitter<EventArgs<Slick.OnKeyDownEventArgs<any>>>;

    //# emit event, if Active Cell Changed in grid
    @Output()
    private readonly onActiveCellChanged: EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>;

    //#
    @Output()
    private readonly onActiveCellPositionChanged: EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>;

    @Output()
    private readonly onSort: EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>;

    @Output()
    private readonly onSorted: EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>;

    @Output()
    private readonly onBeforeEditCell: EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>;

    @Output()
    private readonly onCellChange: EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>;

    @Output()
    private readonly onBeforeCellEditorDestroy: EventEmitter<EventArgs<Slick.OnBeforeCellEditorDestroyEventArgs<any>>>;

    @Output()
    private readonly onViewportChanged: EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>;

    @Output()
    private readonly onSelectedRowsChanged: EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>;

    @Output()
    private readonly onHeaderCellRendered: EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>;

    @Output()
    private readonly onFiltered: EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>;

    @Output()
    private readonly appliedFilters: EventEmitter<{filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[]}>;

    @Output()
    private readonly onGrouping: EventEmitter<EventArgs<OnGroupingEventArgs<any>>>;

    @Output()
    private readonly onAggregated: EventEmitter<EventArgs<OnGroupingEventArgs<any>>>;

    @Output()
    private readonly onColumnsResized: EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>;

    @Output()
    private readonly onValidatorError: EventEmitter<EventArgs<Slick.OnValidationErrorEventArgs<any>>>;

    @Output()
    private readonly onHeaderContextMenu: EventEmitter<EventArgs<Slick.OnHeaderContextMenuEventArgs<any>>>;

    @Output()
    private readonly onContextMenu: EventEmitter<EventArgs<Slick.OnContextMenuEventArgs<any>>>;

    @Output()
    private readonly onReady: EventEmitter<boolean>;

    @Output()
    private readonly onDestroy: EventEmitter<boolean>;

    /*@Output()
    private readonly onColumnsReordered: EventEmitter<EventArgs<Slick.OnColumnsReorderedEventArgs<any>>>;*/

    //@Output()
    //private readonly onInitialized: EventEmitter<EventArgs<Slick.Grid<any>>>;

    get htmlElement(): HTMLElement{
        return this.elementRef.nativeElement;
    }

    private filteredColumns: string[];

    async ngAfterViewChecked(): Promise<void>{

        if (this.resizeGridViewChecked){
            //console.log('resizeGridViewChecked')
            if (this.grid){
                this.resizeGridViewChecked = false;
                this.grid.resizeCanvas();
            }
        }

        //# initialise grid
        if (this.grid || this.gridInitiating)
            return;

        this.gridInitiating = true;

        this.cssClasses = this.css;

        this.translates = await this.translateService.get(['NoData']).toPromise();

        this.grid = new Slick.Grid(this.gridRef.nativeElement, this.data, [], this.options);
        //console.log(this.options.frozenColumn, this.test, 'init grid')
        // this.helper.wait(() => this.grid.setOptions(this.options));
        this.grid.onClick.subscribe((e, data) => this.onClick.emit(new EventArgs(e, data)));
        this.grid.onDblClick.subscribe((e, data) => this.onDblClick.emit(new EventArgs(e, data)));
        this.grid.onKeyDown.subscribe((e, data) => this.onKeyDown.emit(new EventArgs(e, data)));
        this.grid.onActiveCellChanged.subscribe((e, data) => this.onActiveCellChanged.emit(new EventArgs(e, data)));
        this.grid.onActiveCellPositionChanged.subscribe((e, data) => this.onActiveCellPositionChanged.emit(new EventArgs(e, data)));
        //this.grid.onSort.subscribe((e, data) => this.onSort.emit(new EventArgs(e, data)));
        this.grid.onSort.subscribe((e, data) => this.sortData(e, data));
        this.grid.onBeforeEditCell.subscribe((e, data) =>{
            this.onBeforeEditCell.emit(new EventArgs(e, data));
            return !e.isPropagationStopped();
        });
        this.grid.onBeforeCellEditorDestroy.subscribe((e, data) => this.onBeforeCellEditorDestroy.emit(new EventArgs(e, data)));
        this.grid.onCellChange.subscribe((e, data) => this.onCellChange.emit(new EventArgs(e, data)));
        this.grid.onViewportChanged.subscribe((e, data) => this.onViewportChanged.emit(new EventArgs(e, data)));
        this.grid.onSelectedRowsChanged.subscribe((e, data) => this.onSelectedRowsChanged.emit(new EventArgs(e, data)));
        this.grid.onHeaderCellRendered.subscribe(this.onGridHeaderCellRendered);
        this.grid.onHeaderCellRendered.subscribe((e, data) => this.onHeaderCellRendered.emit(new EventArgs(e, data)));


        this.grid.onHeaderContextMenu.subscribe((e, data) => this.onHeaderContextMenu.emit(new EventArgs(e, data)));
        this.grid.onContextMenu.subscribe((e, data) => this.onContextMenu.emit(new EventArgs(e, data)));
        this.grid.onColumnsResized.subscribe((e, data: any) => {
            if (this.manualEllipsis){
                this.manualEllipsisFunc(data.triggeredByColumn);
            }
            this.onColunmResizeFunc(e, data);
        });
        this.grid.onColumnsReordered.subscribe((e, data) => {
            // this.renderedColumns = [];
            this.onColunmResizeFunc(e, data)
        });
        this.grid.onValidationError.subscribe((e, data) => this.onValidatorError.emit(new EventArgs(e, data)));

        this.setColumns(this.columns);

        if (this.selection){
            this.grid.setSelectionModel(this.selection);
            let cellExternalCopyManagerOptions = {
                readOnlyMode : true,
                includeHeaderWhenCopying : false,
                dataItemColumnValueExtractor: (item, columnDef): string  => columnDef.formatter ? columnDef.formatter(null, null, item[columnDef.id]) : item[columnDef.id]
            };
            this.grid.registerPlugin(new Slick['CellExternalCopyManager'](cellExternalCopyManagerOptions));
        }

        this.grid.registerPlugin(new Slick['AutoColumnSize']());

        this.setCellStyles();
        this.registerPlugins();
        this.toggleHideGridFunc();

        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            // let headers = document.getElementsByClassName('slick-header-column');
            // for (let i = 0; i < headers.length; i++){
            //     headers[i].classList.add('box-sizing-border-box')
            // }
        }

        this.universalData = [];
        this.universalSettings = new UniversalListSettings('1', '1');
        this.updatePopper = 0;

        let unGenerator = new ColumnsGenerator<SlickFilterItem>(this.translateService, this.renderer,  this.elementRef),
            unColSettings = [
                new ColumnSettingsBase(1, 'name', 'search-string', null, 'Name', 'string', 1, 150, 10)
            ]
        this.unColSettings = await unGenerator.columnsGenerate([], unColSettings, true);

        this.filterBehavior = this.filterBehaviorIn ? this.filterBehaviorIn : this.gridRef.nativeElement.parentElement.parentElement;

        this.onReady.emit(true);


        // For change in node modules

        /*var header = $("<div class='ui-state-default slick-header-column' />")
            .html("<span class='slick-column-name'>" + m.name + "</span>")
            .outerWidth(m.width - headerColumnWidthDiff)
            .attr("id", "" + uid + m.id)
            .attr("title", m.toolTip || "")
            .data("column", m)
            .addClass(m.headerCssClass || "")
            .appendTo($headers);*/

        //this.onInitialized.emit(new EventArgs(new Slick.EventData(), this.grid));
        this.gridInitiating = false;
        this.resizeGridViewChecked = true;
    }

    ngOnDestroy(): void{
        this.destroyGrid();
    }

    destroyGrid = (): void =>{
        if (!this.grid)
            return;

        this.removeDataViewListeners();

        this.grid.destroy();
        this.grid = null;
        this.onDestroy.emit(true);
    }

    //Resize grid when dimensions of window changeng
    @HostListener('window:resize')
    resizeGrid = (): void =>{
        if (this.grid){
            this.grid.resizeCanvas();
            this.dropDownPopper && this.dropDownPopper.update();
            this.helper.wait( () => this.updatePopper = Math.random()*100);
        }

    }

    //# uncnown
    initializeAngularEditor = (editor: IAngularEditor): void =>{
        editor.initialize(this.appRef, this.resolver, this.injector, this.renderer);
    }

    //# if columns changed width or order emit event
    onColunmResizeFunc = (e, data): void =>{
        let event = new EventArgs(e, data);
        this.onColumnsResized.emit(event);

        if (!this.propsName){
            return
        }

        // console.log(event, this.propsName.moduleName, this.propsName.tableName, this.slickGridProp, 'onColunmResizeFunc')

        this.commonData.saveSlickGridProp(event, this.propsName.moduleName, this.propsName.tableName, this.slickGridProp)
    }


    //# throw standard methods
    getActiveCell = (): Slick.Cell =>{
        return this.grid.getActiveCell();
    }

    //# throw standard methods
    setActiveCell = (row: number, cell: number, suppressActiveCellChangedEvent?: boolean): void =>{
        (this.grid as any).setActiveCell(row, cell, null, null, suppressActiveCellChangedEvent);
    }

    //# throw standard methods
    scrollCellIntoView = (row: number, cell: number, doPaging: boolean): void =>{
        this.grid.scrollCellIntoView(row, cell, doPaging);
    }

    //# throw standard methods
    getCellNode = (row: number, cell: number): HTMLElement =>{
        return this.grid ? this.grid.getCellNode(row, cell) : null;
    }

    //# add plugin to list, register it
    registerPlugin = (plugin: Slick.Plugin<any>): void =>{
        if (!this.pluginsToRegister)
            this.pluginsToRegister = [];

        this.pluginsToRegister.push(plugin);
        this.registerPlugins();
    }

    //# set grid options
    setOptions = (options: Slick.GridOptions<any>): void =>{
        this.optionsInput = options;
        //this.grid.setOptions(options);

    }

    //# freeze columns in grid
    setFreezeColumns = (qnt: number): void =>{
        // this.grid.setOptions({ 'frozenColumn': qnt - 1 });

        this.options.frozenColumn = qnt - 1;
        this.optionsInput = this.options;
        this.columns.forEach((item, i) => {
            if (qnt - 1 >= i){
                // item.headerCssClass = 'frozen'
                // item.cssClass = 'frozen'
            } else {
                // item.headerCssClass = ''
                // item.cssClass = ''
            }
        })
        this.setColumns(this.columns);
        this.resizeGridViewChecked = true;


        //this.resizeGrid();
        //this.grid.setOptions(options);

    }

    //# throw standard methods
    getOptions = (): Slick.GridOptions<any> =>{
        return this.grid.getOptions();

    }

    //# get cell editor
    getCellEditor = (): any => {
        return this.grid.getCellEditor();
    }

    //# set focus for grid
    setFocus = (): void =>{
        this.grid.getCanvasNode().focus();

    }

    //# set sort columns for grid
    setSortColumns = (cols: { columnId: string; sortAsc: boolean }[]): void =>{
        this.grid.setSortColumns(cols);

    }

    //# throw standard methods
    focus = (): void =>{
        this.grid.focus();
    }

    //# throw standard methods
    getViewport = (): any =>{
        return this.grid.getViewport();
    }

    //# throw standard methods
    invalidateAllRows = (options: Slick.GridOptions<any>): void =>{
        this.grid.invalidateAllRows();
    }

    //# throw standard methods
    getColumnIndex = (id: string): number =>{
        return this.grid.getColumnIndex(id);
    }

    //# throw standard methods
    editActiveCell = (editor?: Slick.Editors.Editor<any>): void =>{
        this.grid.editActiveCell(editor);
    }

    //# throw standard methods
    invalidate = (): void =>{
        this.grid.invalidate();
    }

    //# throw standard methods
    invalidateRow = (row: number): void =>{
        this.grid.invalidateRow(row);
    }

    //# throw standard methods
    render = (): void =>{
        this.grid.render();
    }

    //# throw standard methods
    resizeCanvas = (): void =>{
        this.grid.resizeCanvas();
    }

    //# throw standard methods
    setColumns = (columns): void =>{
        this.columns = columns;
        if (this.grid){
            //this.renderedColumns = [];
            this.grid.setColumns(columns);
        }
    }

    //# remove current filters from list
    clearFilters = (ids: string[] = null, refreshColumns: boolean = true): void =>{
        if (ids){
            let idx: number[] = [];

            ids.forEach(item =>{
                this.filteredColumns.forEach((inItem, i) =>{
                    if (inItem === item){
                        idx.push(i);
                    }
                });

                // this.filterHelper.filters.forEach((inItem, i) =>{
                //     if (inItem.column.id === item){
                //         idx2.push(i);
                //     }
                // });
            });

            idx.reverse();
            idx.forEach(item => this.filteredColumns.splice(item, 1));
            idx.forEach(item => this.filterHelper.filters.splice(item, 1));

        } else{
            this.filteredColumns.length = 0;
            this.filterHelper.filters.length = 0;
        }
        refreshColumns && this.setColumns(this.columns);
        this.dataView.refresh();
    }

    //# add filters to slickgrid
    addFilters = (filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[]): void =>{
        if (filteredColumns && filteredColumns.length > 0 && filters && filters.length > 0){
            //console.log(filters, 'addFilters')
            this.filteredColumns = filteredColumns;
            this.filterHelper.filters = filters;
            // refreshColumns && this.setColumns(this.columns);
            this.setColumns(this.columns);
            this.dataView.refresh();
        }
    }

    getEditorLock = (): EditorLock<any> => {
        return this.grid.getEditorLock()
    }

    //# throw standard methods
    setSortColumn = (colId: string, asc: boolean): void =>{
        this.grid.setSortColumn(colId, asc);
    }

    //# throw standard methods
    autosizeColumns = (columns): void =>{
        this.grid.autosizeColumns();
    }

    //# throw standard methods
    updateColumnHeader = (columnName: string): void =>{
        this.grid.updateColumnHeader(columnName);
    }

    //# throw standard methods
    setHeaderRowVisibility = (visible: boolean): void =>{
        this.grid.setHeaderRowVisibility(visible);
    }

    //# throw standard methods
    getSelectedRows = (): number[] =>{
        return this.grid.getSelectedRows();
    }

    //# throw standard methods
    setSelectedRows = (rows: number[]): void =>{
        this.grid.setSelectedRows(rows);
    }

    //# throw standard methods
    getRenderedRange = (viewportTop?: number, viewportLeft?: number): Slick.Viewport =>{
        return this.grid.getRenderedRange(viewportTop, viewportLeft);
    }

    //# throw standard methods
    getDataItem = (index: number): any =>{
        return this.grid.getDataItem(index);
    }

    //# throw standard methods
    updateRow = (row: number): void =>{
        this.grid.updateRow(row);
    };

    //# throw standard methods
    getColumns = (): Slick.Column<any>[] =>{
        return this.grid && this.grid.getColumns();
    };

    //# throw standard methods
    resetActiveCell = (): void =>{
        this.grid && this.grid.resetActiveCell();
    };

    //# throw standard methods
    getCellFromEvent = (e: any): any =>{
        return this.grid.getCellFromEvent(e);
    };

    //# throw standard methods
    syncGridCellCssStyles = (key: string): void =>{
        if (this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridCellCssStyles(this.grid, key);
    };

    //# throw standard methods
    syncGridSelection = (preserveHidden: boolean): void =>{
        if (this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridSelection(this.grid, preserveHidden);
    };

    //# throw standard methods
    private setColumnsProps = (): void =>{
        this.commonData.setSlickGridProp([new GetSlickGridProp(this.columns, this.propsName.tableName)], this.slickGridProp);

        if (this.grid){
            this.sortColumns ? this.sortColumns(this.columns) : null;
            this.setColumns(this.columns);
        }
    };

    //# set groupings to grid
    // TODO
    public setGrouping = (groupings: Slick.Data.GroupingOptions<any>[]): void =>{

        this.dataView.setGrouping(groupings);
        if (!groupings && !groupings.length){
            this.columns.forEach(item => {
                item.grouping.aggregated = false;
                item.grouping.disableAggr = true;
                item.grouping.aggregation = new AggregationSelector(item.id, item.name, new Aggregation(false, false, false, false));
            })
        }

        // if (this.grid){
        //     this.sortColumns ? this.sortColumns(this.columns) : null;
        //     this.setColumns(this.columns);
        // }
    };

    //# load
    private setSlickGridProps = (): void =>{
        //this.hideGrid = true;
        this.commonData.saveUserProp.getSlickGridProperties(this.propsName.moduleName, [this.propsName.tableName]).subscribe(prop =>{
            this.slickGridProp = !prop.data ? [] : JSON.parse(prop.data);
            this.setColumnsProps();

            //this.hideGrid = false;
        });
    };

    private toggleHideGridFunc = (): void =>{
        this.helper.wait(() => {
            if (!this.dataView.getItems().length && this.showNoData){
                this.hideGrid = true;
            } else{
                this.hideGrid = false;
            }
            this.resizeGridViewChecked = true;
        })
    }

    private removeDataViewListeners = (): void =>{
        if (this.dataView){
            this.dataView.onRowCountChanged.unsubscribe(this.onDataViewRowCountChanged);
            this.dataView.onRowsChanged.unsubscribe(this.onDataViewRowsChanged);
        }
    };

    private removeCellStyles = (): void =>{
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.removeCellCssStyles(key);
    };

    private setCellStyles = (): void =>{
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.setCellCssStyles(key, this.cellStyles[key]);
    };

    private onDataViewRowCountChanged = (/*e: Slick.EventData, args: Slick.Data.OnRowCountChangedEventData*/): void =>{
        this.grid.updateRowCount();
        this.grid.render();
    };

    private onDataViewRowsChanged = (e: Slick.EventData, args: Slick.Data.OnRowsChangedEventData): void =>{
        this.grid.invalidateRows(args.rows);
        this.grid.render();
        this.toggleHideGridFunc()
    };

    private registerPlugins = (): void =>{
        if (!this.grid || !this.pluginsToRegister)
            return;

        this.pluginsToRegister.forEach(p => this.grid.registerPlugin(p));
        this.pluginsToRegister = null;
    };

    private sortData = (event: Slick.EventData | DOMEvent, args: Slick.OnSortEventArgs<any>): void =>{

        if (this.onSort.observers.length > 0){
            this.onSort.emit(new EventArgs(event, args));
            return;
        }
        const sorter = this.sorter || new DataSorter<any>();


        sorter.sort(args);

        this.onSorted.emit(new EventArgs(event, args));
    };

    //# custom selection model for universal list component
    //public customSelect: (data: SlickFilterItem[], filteredData: SlickFilterItem[], selected: SlickFilterItem[], row: SlickFilterItem, maxPosition: { position: number },  selectAll: boolean) => void;

    public customSelect = (data: SlickFilterItem[], filteredData: SlickFilterItem[], selected: SlickFilterItem[], row: SlickFilterItem, maxPosition: { position: number },  selectAll: boolean): void => {
        let idsToDelete = [];
        switch (row.rowType) {
            case DropdownFilterType.NonBlank:
                data.forEach(item => {
                    if (item.rowType === DropdownFilterType.ByValue){
                        maxPosition.position = row.position = ++maxPosition.position;

                        if(!item.selected){
                            selected.push(item);
                        } else if (!row.selected) {
                            idsToDelete.push(item.id);
                        }

                        item.selected = row.selected;
                    }
                });
                break;
            case DropdownFilterType.Blank:
                break;
            default:
                let notBlank = data.filter( i => i.rowType === DropdownFilterType.ByValue),
                    quantityNotBlank = notBlank.length,
                    selectedNotBlankQuantity = notBlank.filter( i => i.selected && i.rowType === DropdownFilterType.ByValue).length,
                    nonBlankRow = data.find(i => i.rowType === DropdownFilterType.NonBlank),
                    selectedNonBlankRow = selected.some(item => item.rowType === DropdownFilterType.NonBlank);


                if (nonBlankRow){
                    nonBlankRow.selected = quantityNotBlank === selectedNotBlankQuantity;

                    if (nonBlankRow.selected){
                        !selectedNonBlankRow && selected.push(nonBlankRow)
                    } else{
                        selectedNonBlankRow && this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank)
                    }
                }

                //this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank);
                break;
        }

        if (idsToDelete.length){
            let selectedObj = this.helper.arrToObj(selected, 'id');
            idsToDelete.forEach(item =>{
                delete selectedObj[item];
            });

            selected.length = 0;

            for (let prop in selectedObj){
                selected.push(selectedObj[prop]);
            }

            let nonBlankRow = data.find(i => i.rowType === DropdownFilterType.NonBlank),
                selectedNonBlankRow = selected.some(item => item.rowType === DropdownFilterType.NonBlank);

            if (nonBlankRow && nonBlankRow.selected && !selectedNonBlankRow){
                selected.push(nonBlankRow)
            } else if (nonBlankRow && !nonBlankRow.selected && selectedNonBlankRow){
                this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank)
            }

            selected.sort((a: SlickFilterItem, b: SlickFilterItem) => a.position - b.position );
        }
    };

    //# add blank, non-blank items to universal list
    private addBlankNonBlank = (filteredData: SlickFilterItem[], translates: {[key: string]: string}, hasNotEmptyData: boolean, first: boolean = false): void => {
        let blank,
            nonBlank,
            maxId = filteredData.length ? Math.max.apply(null, filteredData.map(item => item.id)) : 0;

        blank = new SlickFilterItem(maxId + 1, false, translates.Blank_Are, DropdownFilterType.Blank);
        blank.value = translates.Blank_Are;
        nonBlank = new SlickFilterItem(maxId + 2, false, translates.NonBlank_Are, DropdownFilterType.NonBlank);
        nonBlank .value = translates.NonBlank_Are;

        !first ? filteredData.push(blank) : filteredData.unshift(blank);

        hasNotEmptyData
            ? !first
                ? filteredData.push(nonBlank)
                : filteredData.unshift(nonBlank)
            : null;
    };

    //# define filter type
    public filterType = (data: SlickFilterItem[]): DropdownFilterType =>{
        let all, blank, nonBlank, byValue;
        let type: DropdownFilterType = DropdownFilterType.None;
        data.forEach(item =>{
            switch (item.rowType){
                case DropdownFilterType.All:
                    all = true;
                    break;
                case DropdownFilterType.Blank:
                    blank = true;
                    break;
                case DropdownFilterType.NonBlank:
                    nonBlank = true;
                    break;
                case DropdownFilterType.ByValue:
                    byValue = true;
                    break;
            }
        });

        if (all || (blank && nonBlank)){
            type = DropdownFilterType.All;
        } else if (byValue){
            type = DropdownFilterType.ByValue;
        } else if (blank){
            type = DropdownFilterType.Blank;
        } else if (nonBlank){
            type = DropdownFilterType.NonBlank;
        }

        return type;
    };

    //# add dropdown filter
    private setDropdownFilter = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void =>{
        if (this.denyFilters){
            return;
        }

        const renderer = column.dropdownFilter.renderer;

        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        //# add button to column header
        const btn = renderer.createElement('button');
        //let rendered = column.dropdownFilter.rendered;
        renderer.addClass(btn, 'dropdown-toggle');
        renderer.addClass(btn, 'dropdown-filter-btn');
        renderer.addClass(btn, 'fa');
        renderer.addClass(btn, 'fa-filter');
        renderer.appendChild(headerCell, btn);
        renderer.setAttribute(btn,'title', translates.Filter);

        let dropdownVisible = false,
            selectedData: SlickFilterItem[] = this.getSelectedData(column);
            //selectedDataPrev: { type: DropdownFilterType, value: any, text: string }[] = [];

        const btnClick = (e?: MouseEvent) : boolean => {
            if (e){
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            this.universalBTN = btn;
            if (dropdownVisible && this.showUnList){
                this.showUnList = dropdownVisible = false;
                this.addDescription(column, headerCell);
                return true;
            } else if(!dropdownVisible && this.showUnList){
                return false;
            }

            this.universalSettings.showTitle = false;
            this.universalSettings.emitOnClose = true;
            this.universalSettings.applyOneClick = false;
            this.universalSettings.changeSizes = true;
            this.universalSettings.cloneIncomingData = true;
            this.universalSettings.showFooter = true;
            this.universalSettings.showSelectedList = false;
            this.universalSettings.showSearch = false;
            this.universalSettings.hideListenerOnDom = true;
            this.universalSettings.selectAllField = 'name';
            this.universalSettings.denyFilters = true;
            this.universalSettings.startHeight = 350;
            this.universalSettings.popper.behavior = ['left'];
            this.universalSettings.popper.placement = 'bottom-end';

            let selectedObj: {[key: number]: SlickFilterItem} = {};

            this.applyFilter = (event: {data: SlickFilterItem[], selected: SlickFilterItem[]}): void =>{
                //hideDropdown();
                if(!event){
                    // this.helper.wait(() => this.showUnList = dropdownVisible = false);
                    this.showUnList = dropdownVisible = false;
                    this.addDescription(column, headerCell);
                    return;
                }

                selectedData.length = 0;

                let type = this.filterType(event.selected);
                if (type === DropdownFilterType.All){
                    event.data.forEach(item => selectedData.push(item));
                } else {
                    event.selected.forEach(item => selectedData.push(item));
                }

                const index = this.filteredColumns.indexOf(column.field);
                if (!selectedData.length){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'dropdown', selectedData))
                this.filterHelper.onGridFiltered(args);
                this.dataView.refresh();
                this.onFiltered.emit(args);
                this.appliedFilters.emit({filteredColumns : this.filteredColumns, filters: this.filterHelper.filters});
                this.showUnList = dropdownVisible = false;
                this.addDescription(column, headerCell);
            };



            //appendDropdownItem(translates.All, () => selectAll());

            const sorter = new DataSorter();
            let hasEmpty = false,
                hasNotEmtyData = false;

            // let data = this.dataView.getItems();
            let filter = this.filterHelper.filters.find(item => item.column.field === column.field);
            if (filter){
                this.clearFilters([column.field], false)
            }
            let data = this.helper.getRowsFromGridAll(this.dataView);
            // console.log(filter, 'filtering');
            // console.log(data, 'filtering data');
            if (filter){
                this.filterHelper.filters.push(filter);
                this.filteredColumns.push(column.field);
                this.dataView.refresh();
            }

            if (column.dropdownFilter.sourceFilter != null)
                data = data.filter(i => column.dropdownFilter.sourceFilter(i));

            //# remove duplicated items
            let uniqueData = data.map(i =>{
                return i[column.field] ? i[column.field] : null;
            });

            // console.log(this.helper.arrToObj(uniqueData.map(i => i)), 'uniqueData');

            //#add previous filtered items
            if (filter){
                //uniqueData = uniqueData.concat(filter.value.value)
                // console.log(filter.value, 'filter')
            }

            // console.log(this.helper.arrToObj(uniqueData.map(i => i)), 'uniqueData 111');

            let dataObj = this.helper._arrToObj(uniqueData);
            uniqueData = this.helper.objToArr(dataObj);


            //console.log(uniqueData.map(i => i), 'uniqueData 2')


            //# add items to filter list
            this.universalData = uniqueData.sort((a, b) =>{
                const formatter = (column.dropdownFilter.sortFormatter || (v => v));
                return sorter.compare(formatter(a), formatter(b));
            })
                .map((item, i) =>{
                    const value = item;
                    const text = column.dropdownFilter.displayFormatter != null ? column.dropdownFilter.displayFormatter(value) : value;

                    //console.warn(text, value,'filteredData.sort');
                    if (text){
                        let data = new SlickFilterItem(i + 1, false, text, DropdownFilterType.ByValue);
                        data.value = value;
                        hasNotEmtyData = true;
                        return data;
                    }

                    hasEmpty = true;
                    return null;
                }).filter(item => item);



            //# add empty not empty, non empty to list
            hasEmpty && this.addBlankNonBlank(this.universalData, translates, hasNotEmtyData);

            let isMoment: boolean;
            if (this.universalData.length){
                isMoment = this.universalData.some(item => moment.isMoment(item.value));
                console.log(this.universalData, isMoment)
                selectedObj = isMoment
                    ? this.helper.arrToObjMoment(selectedData, 'value', 'format')
                    : this.helper.arrToObj(selectedData, 'value');
            }

            this.universalData.forEach(item => {
                let key: string = isMoment ? (item.value as Moment).format() : item.value as string;
                if (selectedObj[key]){
                    item.selected = selectedObj[key].selected;
                    item.position = selectedObj[key].position;
                }
            });

            this.universalData.sort((a: SlickFilterItem, b: SlickFilterItem) =>  b.position - a.position);

            this.showUnList = dropdownVisible = true;
            this.removeDescription(column, headerCell);
            return true;
        }

        //# when click on button render filter
        renderer.listen(btn, 'click', (e: MouseEvent) =>{
            if(!btnClick(e)) {
                this.helper.waitInterval(btnClick, 100);
            }
        });
    };

    private getSelectedData = (column: ISlickGridColumn<any>): SlickFilterItem[] => {
        let selectedData: SlickFilterItem[] = [];
        if (this.filterHelper.filters && this.filterHelper.filters.length){
            this.filterHelper.filters.forEach(item => {
                if (item.column.field === column.field){
                    selectedData = item.value;
                }
            })
        }
        return selectedData;
    }

    //# set dropdown filter with search
    private setInputFilter = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void =>{
        if (this.denyFilters){
            return;
        }

        const renderer = column.inputFilter.renderer;
        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        const btn = renderer.createElement('button');

        //# add button to column header
        renderer.addClass(btn, 'fa');
        renderer.addClass(btn, 'fa-filter');
        renderer.addClass(btn, 'input-filter-btn');
        renderer.setAttribute(btn, 'title', translates.Filter);
        renderer.appendChild(headerCell, btn);

        let dropdownVisible = false;

        const selectedData: SlickFilterItem[] = this.getSelectedData(column);
        //# when click on button render filter

        const btnClick = (e?: MouseEvent): boolean => {
            if (e){
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            this.universalBTN = btn;
            if (dropdownVisible && this.showUnList){
                this.showUnList = dropdownVisible = false;
                this.addDescription(column, headerCell);
                return true;
            } else if(!dropdownVisible && this.showUnList){
                return false;
            }

            this.universalSettings.showTitle = false;
            this.universalSettings.emitOnClose = true;
            this.universalSettings.applyOneClick = false;
            this.universalSettings.changeSizes = true;
            this.universalSettings.cloneIncomingData = true;
            this.universalSettings.showFooter = true;
            this.universalSettings.showSelectedList = true;
            this.universalSettings.showSearch = true;
            this.universalSettings.hideListenerOnDom = true;
            this.universalSettings.selectAllField = 'name';
            this.universalSettings.denyFilters = true;
            this.universalSettings.startHeight = 350;
            this.universalSettings.popper.behavior = ['left'];
            this.universalSettings.popper.placement = 'bottom-end';

            //this.customSelect = null;

            let uniqueData: string[],
                data: any[],
                selectedObj: {[key: number]: SlickFilterItem} = {},
                hasEmpty = false,
                hasNotEmtyData = false;


            //# remove duplicated items and refresh meta data
            let filter = this.filterHelper.filters.find(item => item.column.field === column.field);
            if (filter){
                this.clearFilters([column.field], false)
            }

            data = this.helper.getRowsFromGridAll(this.dataView);
            //console.log(selectedObj, 'selectedObj');
            //console.log(filter, 'filter');
            // console.log(data.map(i => i), 'data.length ');

            if (filter){
                this.filterHelper.filters.push(filter);
                this.filteredColumns.push(column.field);
                this.dataView.refresh();
            }
            if (column.inputFilter.sourceFilter != null)
                data = data.filter(i => column.inputFilter.sourceFilter(i));

            uniqueData = data.map(i =>{
                return i[column.field] ? i[column.field] : null;
            });


            if (filter){
                //uniqueData = uniqueData.concat(filter.value)
            }

            let dataObj = this.helper._arrToObj(uniqueData);


            uniqueData = this.helper.objToArr(dataObj);


            this.universalData = uniqueData.map((item, i) => {
                if (item){
                    let data = new SlickFilterItem(i + 1, false, item, DropdownFilterType.ByValue);
                    data.value = item;
                    hasNotEmtyData = true;
                    return data;
                }

                hasEmpty = true;
                return null;
                //return new SlickFilterItem(i+1, false, item, DropdownFilterType.ByValue)
            }).filter(i => i);

            //# add empty not empty? non empty to list
            hasEmpty && this.addBlankNonBlank(this.universalData, translates, hasNotEmtyData, true);
            let isMoment: boolean
            if (this.universalData.length){
                isMoment = this.universalData.some(item => moment.isMoment(item.value));
                selectedObj = isMoment
                    ? this.helper.arrToObjMoment(selectedData, 'value', 'format')
                    : this.helper.arrToObj(selectedData, 'value');
            }

            // console.log(selectedObj, 'selectedObj')

            this.universalData.forEach(item => {
                //item.value = item.name;
                let key: string = isMoment ? (item.value as Moment).format() : item.value as string;
                if (selectedObj[key]){
                    item.selected = selectedObj[key].selected;
                    item.position = selectedObj[key].position;
                }
            });

            this.universalData.sort((a: SlickFilterItem, b: SlickFilterItem) =>  b.position - a.position);

            //# apply filter, emit event filter
            this.applyFilter = (event: {data: any[], selected: any[]}): void =>{
                if(!event){
                    this.showUnList = dropdownVisible = false;
                    this.addDescription(column, headerCell);
                    return;
                }

                selectedData.length = 0;

                let type = this.filterType(event.selected);
                if (type === DropdownFilterType.All){
                    event.data.forEach(item => selectedData.push(item));
                } else {
                    event.selected.forEach(item => selectedData.push(item));
                }

                const index = this.filteredColumns.indexOf(column.field);
                if (!selectedData.length){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'input', selectedData));
                this.filterHelper.onGridFiltered(args);
                this.dataView.refresh();
                this.onFiltered.emit(args);
                this.appliedFilters.emit({filteredColumns : this.filteredColumns, filters: this.filterHelper.filters});
                this.addDescription(column, headerCell);
                this.showUnList = dropdownVisible = false;
            };

            this.showUnList = dropdownVisible = true;
            this.removeDescription(column, headerCell);
            return true;
        }

        renderer.listen(btn, 'click', (e: MouseEvent) =>{
            if(!btnClick(e)) {
                this.helper.waitInterval(btnClick, 100);
            }
        });
    };

    //# generate number filter
    private setInputFilterNumber = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void =>{
        if (this.denyFilters){
            return;
        }

        const renderer = column.inputFilter.renderer;
        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        //# add button to column header
        const btn = renderer.createElement('button');

        renderer.addClass(btn, 'fa');
        renderer.addClass(btn, 'fa-filter');
        renderer.addClass(btn, 'input-filter-btn');
        renderer.setAttribute(btn, 'title', translates.Filter);
        renderer.appendChild(headerCell, btn);

        let inputValue1: string = '';
        let inputValue2: string = '';
        let dropdownVisible = false;
        let numberType: number = 1;

        //# when click on button render filter
        renderer.listen(btn, 'click', e =>{
            e.stopPropagation();

            if (dropdownVisible){
                return;
            }

            const dropdown = renderer.createElement('div');
            renderer.addClass(dropdown, 'dropdown-menu');
            renderer.addClass(dropdown, 'number');
            const dropdownInput = renderer.createElement('input');
            renderer.setAttribute(dropdownInput, 'type', 'text');
            renderer.addClass(dropdownInput, 'dropdown-input-1');
            const delimiter = renderer.createElement('span');
            renderer.appendChild(delimiter, renderer.createText('-'));
            renderer.addClass(delimiter, 'dropdown-delimiter');
            const dropdownInput2 = renderer.createElement('input');
            renderer.setAttribute(dropdownInput2, 'type', 'text');
            renderer.addClass(dropdownInput2, 'dropdown-input-2');
            const apply = renderer.createElement('button');
            renderer.addClass(apply, 'btn');
            renderer.addClass(apply, 'btn-primary');
            renderer.addClass(apply, 'apply-filter');
            renderer.appendChild(apply, renderer.createText(translates.Apply));
            const clear = renderer.createElement('button');
            renderer.addClass(clear, 'btn');
            renderer.addClass(clear, 'btn-primary');
            renderer.addClass(clear, 'clear-filter');
            renderer.appendChild(clear, renderer.createText(translates.Clear));
            const dropdownFooter = renderer.createElement('div');
            renderer.addClass(dropdownFooter, 'dropdown-footer');
            const dropdownBtnWrp = renderer.createElement('div');

            const select = renderer.createElement('select');
            renderer.addClass(select, 'dropdown-select');

            this.filterHelper.renderSelect(renderer, select, translates);

            renderer.appendChild(dropdown, select);

            renderer.appendChild(dropdown, dropdownInput);
            renderer.appendChild(dropdown, delimiter);
            renderer.appendChild(dropdown, dropdownInput2);

            renderer.addClass(dropdownBtnWrp, 'dropdown-btn-wrp');
            renderer.appendChild(dropdown, dropdownBtnWrp);
            renderer.appendChild(dropdown, dropdownBtnWrp);

            renderer.appendChild(dropdownFooter, apply);
            renderer.appendChild(dropdownFooter, clear);
            renderer.appendChild(dropdown, dropdownFooter);


            if (inputValue1){
                dropdownInput.value = inputValue1;
            }

            if (inputValue2){
                dropdownInput2.value = inputValue2;
            }

            select.value = numberType;

            //# show two input if beetween
            const showSecondInput = (show: boolean): void =>{
                if (show){
                    renderer.addClass(dropdown, 'small');
                    renderer.addClass(dropdownInput2, 'show');
                    renderer.addClass(delimiter, 'show');
                } else{
                    renderer.removeClass(dropdown, 'small');
                    renderer.removeClass(dropdownInput2, 'show');
                    renderer.removeClass(delimiter, 'show');
                }
            };

            if (numberType === 7){
                showSecondInput(true);
            }

            renderer.listen(select, 'change', (e: any) =>{
                if (e && e.target){

                    if (e.target.value === '7'){
                        showSecondInput(true);
                    } else{
                        showSecondInput(false);
                    }
                    numberType = this.helper.customParseNumber(e.target.value);
                }
            });

            renderer.listen(dropdownInput, 'keyup', (e: KeyboardEvent) =>{
                if (e && e.target && e.keyCode === 13 && e.target as HTMLInputElement){
                    applyFilter();
                }
            });

            let timeout = setTimeout(() =>{
                clearTimeout(timeout);
                timeout = null;
                dropdownInput.focus();
            }, 1);

            // let dropdownPopper: Popper;
            let removeListener: () => void;
            let removeKeyupListener: () => void;

            //# hide filrer
            const hideDropdown = (): void =>{
                removeListener();
                removeKeyupListener();
                renderer.removeClass(dropdown, 'show');
                this.dropDownPopper.destroy();
                renderer.removeChild(column.inputFilter.dropdownContainer, dropdown);
                this.addDescription(column, headerCell);
                dropdownVisible = false;
            };

            //# validate entered into unputs data
            const validateData = (): boolean =>{

                if (this.helper.customParseNumber(inputValue1) === null && this.helper.customParseNumber(inputValue2) === null){
                    return false;
                }

                if (isNaN(this.helper.customParseNumber(inputValue1)) || isNaN(this.helper.customParseNumber(inputValue2))){
                    return true;
                }

                return numberType === 7 ? this.helper.customParseNumber(inputValue1) >= this.helper.customParseNumber(inputValue2) ||
                    this.helper.customParseNumber(inputValue1) === null && this.helper.customParseNumber(inputValue2) !== null ||
                    this.helper.customParseNumber(inputValue2) === null && this.helper.customParseNumber(inputValue1) !== null
                    : false;
            };

            //# toggle highlight inputs after validation
            const displayValidation = (validate: boolean): void =>{
                if (validate){
                    renderer.addClass(dropdownInput, 'wrong');
                    renderer.addClass(dropdownInput2, 'wrong');
                } else{
                    renderer.removeClass(dropdownInput, 'wrong');
                    renderer.removeClass(dropdownInput2, 'wrong');
                }
            };

            //# apply filter and emit event
            const applyFilter = (): void =>{
                let validate = validateData();
                displayValidation(validate);
                if (validate) return;


                hideDropdown();
                let type: DropdownFilterType;

                type = inputValue1 ? DropdownFilterType.ByValue : DropdownFilterType.All;

                const index = this.filteredColumns.indexOf(column.field);
                if (!inputValue1){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                let data: number[] = [this.helper.customParseNumber(inputValue1), this.helper.customParseNumber(inputValue2)];

                let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'input-number', data, numberType));
                this.filterHelper.onGridFiltered(args);
                this.dataView.refresh();
                this.onFiltered.emit(args);
                this.appliedFilters.emit({filteredColumns : this.filteredColumns, filters: this.filterHelper.filters});
            };

            renderer.listen(dropdownInput, 'input', (e) =>{
                inputValue1 = e.target.value;
                displayValidation(validateData());
            });
            renderer.listen(dropdownInput2, 'input', (e) =>{
                inputValue2 = e.target.value;
                displayValidation(validateData());
            });

            renderer.listen(apply, 'click', () => applyFilter());

            const clearFilter = (): void =>{
                inputValue1 = '';
                inputValue2 = '';
                numberType = 1;
                applyFilter();
            };

            renderer.listen(clear, 'click', () => clearFilter());

            renderer.appendChild(column.inputFilter.dropdownContainer, dropdown);
            this.dropDownPopper = new Popper(btn, dropdown, {placement: 'bottom-end'});
            renderer.setStyle(dropdown, 'width', `${130}px`);

            renderer.addClass(dropdown, 'show');

            setTimeout(() =>{
                removeListener = renderer.listen('body', 'mousedown', (event: MouseEvent) =>{
                    let target = event.target,
                        hideFilter: boolean = true;
                    if (!target || !(event.target instanceof HTMLElement)){
                        hideDropdown();
                        return;
                    }

                    if (btn && btn.isSameNode(target) && dropdownVisible){

                        let timeout = setTimeout(() =>{
                            clearTimeout(timeout);
                            timeout = null;
                            hideDropdown();
                        }, 300);
                        return;
                    }

                    while (target){
                        if (dropdown && dropdown.isSameNode(target) || btn && btn.isSameNode(target)){
                            hideFilter = false;
                            break;
                        }

                        target = this.renderer.parentNode(target);
                    }

                    if (hideFilter){
                        hideDropdown();
                    }
                });

                removeKeyupListener = renderer.listen('body', 'keyup', (event: KeyboardEvent) =>{
                    if (event){
                        switch (event.keyCode){
                            case 13:
                                applyFilter();
                                break;
                            case 27:
                                clearFilter();
                                break;
                        }
                    }
                });
            }, 1);

            this.removeDescription(column, headerCell);
            dropdownVisible = true;
        });
    }

    //# render buttons for grouping and aggregation, toggle them
    private setGroupingBtn = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void =>{

        if (this.denyGrouping){
            return;
        }

        const renderer = column.grouping.renderer;

        //# render button for toggle grouping
        const btn = renderer.createElement('button');

        renderer.addClass(btn, 'fa');
        renderer.addClass(btn, 'grouping-btn');
        renderer.setAttribute(btn, 'title', translates.Grouping);
        renderer.appendChild(headerCell, btn);

        let grouped: boolean = column.grouping.grouped;

        if (grouped){
            renderer.addClass(btn, 'fa-object-ungroup');
        } else{
            renderer.addClass(btn, 'fa-object-group');
        }


        // const selectedData: string[] = [];
        //# toggle grouping on click
        renderer.listen(btn, 'click', e =>{
            e.stopPropagation();
            grouped = !grouped;
            if (grouped){
                renderer.removeClass(btn, 'fa-object-group');
                renderer.addClass(btn, 'fa-object-ungroup');
            } else{
                renderer.addClass(btn, 'fa-object-group');
                renderer.removeClass(btn, 'fa-object-ungroup');
            }
            column.grouping.grouped = grouped;
            this.onGrouping.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(column, grouped ? 'add' : 'remove')));
        });

        if (column.type !== 'number' || this.denyGrouping || this.denyAggregation) return;

        //# render button for aggregations
        const btnAg = renderer.createElement('button');
        let dropdownVisible = false;

        renderer.addClass(btnAg, 'aggregate-btn');

        column.grouping.disableAggr && renderer.addClass(btnAg, 'disabled');

        //column.grouping.disableAggr && renderer.setAttribute(btnAg, 'disabled', true);

        renderer.appendChild(btnAg, renderer.createText('Ag'));
        renderer.setAttribute(btnAg, 'title', translates.Aggregation);
        renderer.appendChild(headerCell, btnAg);

        let aggregated: boolean = column.grouping.aggregated;
        let aggregation: AggregationSelector = this.helper.copyAggregatorSelector(column.grouping.aggregation);

        // if (!aggregation){
        //     aggregation = new AggregationSelector(column.id, column.name, new Aggregation(false, false, false, false))
        // }

        aggregated ? renderer.addClass(headerCell, 'aggregated') : renderer.removeClass(headerCell, 'aggregated');

        //# render list of aggregations on click
        renderer.listen(btnAg, 'click', e =>{
            e.stopPropagation();

            if (dropdownVisible || column.grouping.disableAggr){
                return;
            }

            const clear = renderer.createElement('button');
            const apply = renderer.createElement('button');
            const dropdown = renderer.createElement('div');
            const dropdownBtnWrp = renderer.createElement('div');
            const dropdownFooter = renderer.createElement('div');
            renderer.addClass(dropdown, 'dropdown-menu');
            renderer.addClass(dropdownBtnWrp, 'dropdown-btn-wrp');
            renderer.addClass(dropdownFooter, 'dropdown-footer');
            renderer.addClass(apply, 'btn');
            renderer.addClass(apply, 'btn-sm');
            renderer.addClass(apply, 'btn-primary');
            renderer.addClass(apply, 'apply-filter');
            renderer.addClass(clear, 'btn');
            renderer.addClass(clear, 'btn-sm');
            renderer.addClass(clear, 'btn-primary');
            renderer.addClass(clear, 'clear-filter');
            renderer.appendChild(clear, renderer.createText(translates.Clear));
            renderer.appendChild(apply, renderer.createText(translates.Apply));
            renderer.appendChild(dropdownFooter, apply);
            renderer.appendChild(dropdownFooter, clear);
            renderer.appendChild(dropdown, dropdownBtnWrp);
            renderer.appendChild(dropdown, dropdownFooter);

            //let dropdownPopper: Popper;

            let removeListener: () => void;
            let removeKeyupListener: () => void;

            //# hide aggregation list
            const hideDropdown = (): void =>{
                removeListener();
                removeKeyupListener();
                renderer.removeClass(dropdown, 'show');
                this.dropDownPopper.destroy();
                renderer.removeChild(column.grouping.dropdownContainer, dropdown);
                this.addDescription(column, headerCell);
                dropdownVisible = false;
            };

            //# toggle aggregation
            const addSelected = (prop: string): void =>{
                aggregation.data[prop] = !aggregation.data[prop];
            };

            //# emit selected aggregation and apply it
            const applyFilter = () =>{
                hideDropdown();

                column.grouping.aggregated = aggregated = this.helper.hasSelectedAg(aggregation);
                column.grouping.aggregation = null;
                column.grouping.aggregation = aggregation;
                aggregated ? renderer.addClass(headerCell, 'aggregated') : renderer.removeClass(headerCell, 'aggregated');
                this.onAggregated.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(column, aggregated ? 'add' : 'remove', [aggregation])));
            };

            //# add aggregation item to list of aggregations
            const appendDropdownItem = (prop: string, text: string, onClick: () => void): void =>{
                const menuItem = renderer.createElement('button');
                const wrpMenuItem = renderer.createElement('div');
                const inputMenuItem = renderer.createElement('input');
                renderer.setAttribute(inputMenuItem, 'type', 'checkbox');
                renderer.setAttribute(menuItem, 'type', 'button');
                renderer.addClass(wrpMenuItem, 'dropdown-item-wrp');
                renderer.addClass(menuItem, 'dropdown-item');
                renderer.addClass(inputMenuItem, 'dropdown-checkbox');
                renderer.appendChild(menuItem, renderer.createText(text));
                renderer.listen(wrpMenuItem, 'click', onClick);

                if (aggregation.data[prop]){
                    inputMenuItem.checked = true;
                }

                renderer.listen(wrpMenuItem, 'click', ($event: any) =>{

                    let target = $event.target;
                    if (target){
                        let input: HTMLInputElement;
                        if (target.classList.contains('dropdown-item')){
                            input = target.parentElement.querySelector('.dropdown-checkbox');
                        } else if (target.classList.contains('dropdown-item-wrp')){
                            input = target.querySelector('.dropdown-checkbox');
                        }

                        if (input){
                            input.checked = !input.checked;
                        }

                    }
                });

                renderer.appendChild(wrpMenuItem, inputMenuItem);
                renderer.appendChild(wrpMenuItem, menuItem);
                renderer.appendChild(dropdownBtnWrp, wrpMenuItem);
            };

            //# get translated aggregations
            const getText = (prop: string): string =>{
                let result: string = '';
                switch (prop){
                    case 'avg':
                        result = translates.Avg;
                        break;
                    case 'sum':
                        result = translates.Sum;
                        break;
                    case 'min':
                        result = translates.Min;
                        break;
                    case 'max':
                        result = translates.Max;
                        break;
                }
                return result;
            };

            for (let prop in aggregation.data){
                let text: string = getText(prop);
                appendDropdownItem(prop, text, () => addSelected(prop))
            }

            renderer.listen(apply, 'click', () => applyFilter());
            renderer.listen(clear, 'click', () =>{
                aggregation = this.helper.copyAggregatorSelector(column.grouping.aggregation);
                hideDropdown();
            });
            renderer.appendChild(column.grouping.dropdownContainer, dropdown);
            this.dropDownPopper = new Popper(btnAg, dropdown, {placement: 'bottom-end'});
            renderer.setStyle(dropdown, 'width', `${100}px`);
            renderer.addClass(dropdown, 'show');

            setTimeout(() =>{
                removeListener = renderer.listen('body', 'mousedown', (event: MouseEvent) =>{
                    // console.log(event.target, 'event.target')
                    let target = event.target,
                        hideFilter: boolean = true;
                    if (!target || !(event.target instanceof HTMLElement)){
                        hideDropdown();
                        return;
                    }

                    if (btnAg && btnAg.isSameNode(target) && dropdownVisible){
                        let timeout = setTimeout(() =>{
                            clearTimeout(timeout);
                            timeout = null;
                            hideDropdown();
                        }, 300);
                        return;
                    }
                    //console.log(dropdown, 'body  mousedown dropdown');
                    while (target){
                        //console.log(target, 'body  mousedown target');
                        if (dropdown && dropdown.isSameNode(target) || btnAg && btnAg.isSameNode(target)){
                            hideFilter = false;
                            break;
                        }

                        target = this.renderer.parentNode(target);
                    }
                    //console.log(hideFilter, 'body  mousedown hideFilter');

                    if (hideFilter){
                        applyFilter();
                    }
                });

                removeKeyupListener = renderer.listen('body', 'keyup', (event: KeyboardEvent) =>{
                    if (event){
                        switch (Number(event.key)){
                            case 13:
                                applyFilter();
                                break;
                            case 27:
                                hideDropdown();
                                break;
                        }
                    }
                });


            }, 1);
            this.removeDescription(column, headerCell);
            dropdownVisible = true;
        });
    };

    //# add description tooltip to grid header
    private addDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void =>{
        if (column.description === column.descriptionKey){
            return;
        }

        let span = $(headerCell).find( '.slick-column-name')[0];
        this.renderer.setAttribute(span, 'title', column.description);
        this.renderer.setAttribute(span, 'data-toggle', 'tooltip');
        this.renderer.setAttribute(span, 'data-html', 'true');
        // this.renderer.setAttribute(headerCell, 'data-container', '#' + this.gridGUID);
        this.renderer.listen(span, 'mouseleave', (e: MouseEvent) => this.helper.remTooltip(e));
        $(span).tooltip({trigger: 'hover', offset: "50px, 0", template: '<div class="tooltip stocks-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'})
    }

    //# remove description tooltip from grid header
    private removeDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void =>{
        $(headerCell).tooltip('dispose')
    }

    //# hide description tooltip from grid header
    private hideDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void =>{
        $(headerCell).tooltip('hide')
    }

    //# show description tooltip from grid header
    private showDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void =>{
        $(headerCell).tooltip('show')
    }

    //# set manual ellipsis to text in column header
    private manualEllipsisFunc = (columnId: string): void => {
        // this.helper.wait(() => {


        const column = this.columns.find(c => c.id === columnId);



        let headerCell = $('.' + this.gridGUID + '_' + column.regColId);
        this.helper.wait(() => {
            let $span = $(headerCell).find( '.slick-column-name').first(),
                lineWidth = $span.outerWidth(),
                $container = $(this.renderer.createElement('div'))
                .css({display: 'inline', width: '10000px', visibility: 'hidden', position: 'absolute', left: '10000px', fontsize: this.manualEllipsis.fontSize}),
                nameArr = column.name.split(' '),
                elArr: {text: string, el: JQuery<HTMLElement>, width: number}[] = [];
            // console.log(lineWidth, column.name)
            nameArr.forEach((text, i, arr) => {
                let padding = arr.length - (i + 1) > 0 ? '0 3.85px 0 0' : 0;
                let $el = $span
                        .clone()
                        .css({display: 'inline', width: 'auto', visibility: 'hidden', position: 'absolute', fontsize: this.manualEllipsis.fontSize, padding})
                        .text(text)
                        .appendTo($container);
                    elArr.push({text, el: $el, width: 0})
                });

            $container.appendTo('body');
            let fullWidth = 0;
            elArr.forEach(item => fullWidth += item.el.outerWidth());

            // console.log(column.name, nameArr, 'nameArr', lineWidth, 'lineWidth', fullWidth, 'fullWidth');

            const needDot = (): void => {
                let lines: {line: number, width: number, text: string}[] = [];
                let cutted = elArr.some(item => {
                    if (!lines.length){
                        lines.push({line: 1, width: 0, text: ''})
                    }

                    let line: {line: number, width: number, text: string} = lines[lines.length - 1];
                    let outerWidth = item.el.outerWidth();
                    if (line.width === 0 && outerWidth  -3.75 >= lineWidth){
                        line.text = item.text;
                        line.width = item.el.outerWidth();
                        lines.push({line: lines.length + 1, width: 0, text: ''})
                    } else if (line.width + outerWidth - 3.75 >= lineWidth){
                        lines.push({line: lines.length + 1, width: item.el.outerWidth(), text: item.text})
                    } else if (line.width + outerWidth - 3.75  < lineWidth){
                        line.text ? line.text += ' ' + item.text : line.text = item.text;
                        line.width += item.el.outerWidth();
                    }

                    // console.log(line.width === 0 && line.width + outerWidth - 3.75 >= lineWidth, line.width + outerWidth - 3.75 >= lineWidth, line.width + outerWidth < lineWidth)
                    //
                    // console.log(item.text, line.text, outerWidth, 'line')

                    if (lines.length > this.manualEllipsis.strings){
                        lines.length = this.manualEllipsis.strings;
                        let name = lines.map(line => line.text).join(' ');
                        if (lineWidth - lines[lines.length - 1].width > 8){
                            name = name + '....';
                        } else {
                            name = name.substring(0, name.length - 3) + '....';
                        }

                        $span.text(name);
                        return true;
                    }
                })
                // console.log(column.name, lines, 'lines')
                !cutted && $span.text(column.name);
            }

            needDot();
            $container.remove();
        }, 5)
        // }, 5)
    }

    //# on grid header cell rendered add filter, aggregation and dropdown to header cell
    private onGridHeaderCellRendered = (event: DOMEvent, args: Slick.OnHeaderCellRenderedEventArgs<any>) =>{
        const column = args.column as ISlickGridColumn<any>;
        //this.renderedColumns.push(args);

        if (!column)
            return;

        if (this.cancelSort){
            // const container = args.node.querySelector('.slick-column-name');
            const container = args.node;
            container.addEventListener('dblclick', () => {
                this.grid.setSortColumns([]);

                // let data = this.dataView.getItems();
                //console.log(data)
                this.dataView.sort((a: any, b: any) => {
                    return a['id'] - b['id'];
                }, true);

                this.grid.invalidate();
                this.grid.render();
                this.helper.wait(() => this.onSorted.emit(null));

                //this.dataView.fastSort('id', false)
            })
        }

        if (this.manualEllipsis){
            $(args.node).addClass(this.gridGUID + '_' + args.column.regColId);
            this.manualEllipsisFunc(column.id);
        }


        if (column.dropdownFilter)
            this.translateService.get(['All', 'Blank_Are', 'NonBlank_Are', 'Apply', 'Cancel', 'Filter']).subscribe(t => this.setDropdownFilter(column, args.node, t));

        if (column.inputFilter && column.inputFilter.type === 'string')
            this.translateService.get(['All', 'Blank_Are', 'NonBlank_Are', 'Apply', 'Clear', 'Selected', 'Filter']).subscribe(t => this.setInputFilter(column, args.node, t));

        if (column.inputFilter && column.inputFilter.type === 'number')
            this.translateService.get(['Apply', 'Clear', 'Selected', 'Between', 'Filter']).subscribe(t => this.setInputFilterNumber(column, args.node, t));

        if (column.grouping)
            this.translateService.get(['Apply', 'Clear', 'Avg', 'Sum', 'Min', 'Max', 'Grouping', 'Aggregation']).subscribe(t => this.setGroupingBtn(column, args.node, t));

        if (column.description){
            this.addDescription(column, args.node);
        }

        if (column.selectAll && column.selectAll.allSelectable){
            const input = this.renderer.createElement('input') as HTMLInputElement;
            input.type = 'checkbox';
            this.renderer.listen(input,
                'change',
                () =>{
                    let items: any[] = this.dataView.getItems();

                    for (const item of items)
                        item[column.field] = input.checked;

                    if (!this.grid)
                        return;

                    this.grid.invalidate();
                    this.grid.render();

                    if (column.selectAll.onSelectionChanged)
                        column.selectAll.onSelectionChanged();
                });

            const container = args.node.querySelector('.slick-column-name');
            this.renderer.appendChild(container, input);
            this.renderer.addClass(container, 'text-center');
        }

        //$(args.data.node).on('hidden.bs.dropdown',
        //    () => {
        //        dropdownVisible = false;

        //        //$(btn).dropdown('destroy');
        //        this.renderer.removeChild('body', dropdown);
        //        //this.renderer.removeAttribute(btn, 'data-toggle');
        //    });
    }
}




// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.component-base.ts